import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useStoreon } from "storeon/react";
import "./login.scss";
import lanetalkLogo from "../../shared/images/logo192.png";
import LoginBox from "./loginBox/LoginBox";
import ForgetPasswordBox from "./forgetPasswordBox/ForgetPasswordBox";
import { LOGIN } from "../../store/auth";
import { getAuth } from "../../services/loginService";
import { error } from "../components/toast/toast";
import { toast } from "react-toastify";
import { LOAD_LOGGED_IN_USER_PROFILE } from "../../store/loggedInUserProfile";

const Login = (props) => {
  const history = useHistory();
  const { dispatch } = useStoreon("auth");
  const [loginSection, setLoginSection] = useState("login");
  const [errors, setErrors] = useState(null);
  const toastId = React.useRef(null);
  const dismissAll = () => {
    toast.dismiss();
  };

  const handleLogin = ({ username, password, rememberme }) => {
    getAuth(username, password).then((res) => {
      if (res && res.error) {
        setErrors(res.error);
        let messageError =
          res.statusCode && res.statusCode === 403
            ? "Invalid email or password. Please try again."
            : res.error;
        toastId.current = error(messageError, {
          autoClose: 15000,
          onClose: () => {
            window.removeEventListener("click", dismissAll);
          },
        });
        window.addEventListener("click", dismissAll);
      } else {
        if (res) {
          if (rememberme) {
            localStorage.setItem(
              "login",
              JSON.stringify({
                username,
                password: btoa(password),
                rememberme,
              })
            );
          } else {
            localStorage.removeItem("login");
          }
          dispatch(LOAD_LOGGED_IN_USER_PROFILE, {
            access_token: res.access_token,
            id: res.id,
          });
          dispatch(LOGIN, { access_token: res.access_token });
          history.push("/");
        }
      }
    });
  };

  const showLoginBox = () => {
    switch (loginSection) {
      case "forgetPassword":
        return (
          <ForgetPasswordBox
            onCancel={() => setLoginSection("login")}
            className="loginBoxClassName"
            title="Forgot Password?"
          />
        );
      default:
        const login = localStorage.getItem("login");
        const values = login
          ? JSON.parse(login)
          : { username: "", password: "", rememberme: false };
        return (
          <LoginBox
            onForgetPasswordClick={() => setLoginSection("forgetPassword")}
            onLogin={handleLogin}
            values={{ ...values, password: atob(values.password) }}
            errors={errors}
            className="loginBoxClassName"
            title="Sign In"
            subtitle={"Welcome to Lanetalk"}
          />
        );
    }
  };
  return (
    <div className="loginPage">
      <div className="joinOurCommunitySection">
        <img src={lanetalkLogo} alt="" />
        <span className="textLogo">Lanetalk</span>
      </div>
      <div className="loginSection">{showLoginBox()}</div>
    </div>
  );
};

export default Login;
